<script lang="ts">
    import { COMMANDS } from "$lib/commands";
    import Search from "$lib/panels/Search.svelte";
    import MenuBar from "$lib/panels/MenuBar.svelte";
    import Tools from "$lib/panels/Tools.svelte";

    import { SplitPanel, TabPanel, GridLayout, createGridLayout } from "svelte-editor-layout/src/lib/layout";
    import { Layout } from "svelte-editor-layout";
    import { createLayout, createLayoutMobile } from "$lib/panels/layout";
    import { onMount } from "svelte";
    import ToolOptionsBar from "$lib/panels/ToolOptionsBar.svelte";

    const layout = createLayoutMobile();

    document.body.classList.add("editor-variables");
    onMount(() => {
        const { add, destroy } = COMMANDS.registerActions("all");

        let panels = ["palette", "layers", "files", "history", "tool-options", "color-picker"] as const;

        for (let panel of panels) {
            add(`view.${panel}`, () => {
                layout.toggle(panel, "panel-bottom");
            });
        }

        return destroy;
    });
</script>

<Layout {layout}>
    <GridLayout id="editor-grid" class="desktop-layout">
        <div class="panel" style="grid-area: menu">
            <MenuBar />
        </div>

        <div class="panel" style="grid-area: tools">
            <Tools />
        </div>

        <div class="content">
            <ToolOptionsBar/>
            <slot />
        </div>

        <TabPanel id="panel-bottom" class="panel top" />
<!--        <TabPanel id="panel-right" class="panel" />-->

<!--        <SplitPanel id="panel-right" class="panel" />-->

    </GridLayout>
</Layout>
<style>
    .content {
        grid-area: content;
        overflow: hidden;
    }

    .active > :global(.icon) {
        color: var(--gacc200);
    }

    .tool:hover > :global(.icon) {
        color: var(--tacc);
    }
</style>